import { useEffect } from 'react'
import { useHeaper } from '@equipmentshare/heaper'
import config from 'config/config'
import { getUniversalHeaderConfig } from 'config/unav'
import { useIdentity } from '@equipmentshare/auth0-react'


const configureIntercom = ( userId: number ) => {
	const { app: { id: appId }, helpOverride } = getUniversalHeaderConfig()
	const triggerId = helpOverride ? helpOverride.id : ''
	// Boot Intercom
	try {
		if ( window.Intercom ) {
			window.Intercom( 'boot', {
				app_id: appId,
				custom_launcher_selector: `#${triggerId}`,
				hide_default_launcher: true,
				user_id: userId,
			} )
		} else {
			// eslint-disable-next-line no-console
			console.warn( 'Intercom not loaded' )
		}
	} catch ( e ) {
		// eslint-disable-next-line no-console
		console.error( 'Failed to initialize intercom widget', e )
	}
}

export type HeaperComponentProps = {
	userId: number,
}
export default function HeaperComponent( { userId }: HeaperComponentProps ) {
	const environment = config.ENVIRONMENT === 'production' ? 'Production' : 'Staging'
	const { accessToken, idToken } = useIdentity()

	useHeaper( 'Inventory', environment, { accessToken, idToken } )
	useEffect( () => {
		configureIntercom( userId )
	}, [] )

	return null
}
